(function () {
    'use strict';

    angular.module('swif.reservations')
    .service('reservationService', ['$q','$location','$interval' , 'swifFrameworkService', '$rootScope',
        function ($q, $location, $interval, swif, $rootScope) {
            var service = {};
            service.requests = {collectionName: 'reservationRequests'};
            service.bookings = {collectionName: 'reservations'};
            service.planning = {collectionName: 'planningReservations'};
            service.recurrence = {collectionName: 'recurrenteReservation'};

            service.bookings.PANEL_FIELDS = [
                'id', 'name', 'note', 'checkin', 'checkout', 'partner_id',
                'partner_invoice_id', 'state', 'reservation_line', 'recipient', 'recipient_phone', 'shipping_address', 'shipping_wished_date'
            ];

            service.recurrences = {};

            service.permissions = {};
            service.permissions.getUserPermissions = function () {
                var user = swif.user.getAuthenticatedUserData();
                var ret = {
                    manager: _.contains(user.access_rights, 'HOTEL_MANA'),
                    superuser: _.contains(user.access_rights, 'HOTEL_USER_AGENT'),
                    internalUser: _.contains(user.access_rights, 'HOTEL_USER_INTERNAL'),
                    externalUser: _.contains(user.access_rights, 'HOTEL_USER_EXT')
                };
                return ret;
            };

            // @NOTE: service.model refers to the current / working model (on form view, for example)
            service.model = null;

            service.onError = function (err) {
                swif.message.addError(err);
                swif.message.loading(service.model, 'ko');
            };
            service.models = {};

            service.purgeAllModels = function () {
                service.models = {};
            };
        }
    ]);

})();
